import axios from 'axios';

export default function createAjax(endPoint, getSession) {
  return async function ajax({ resource, method, data, onUploadProgress }) {
    // token: logged in user token
    const { token } = getSession();

    const url = `${endPoint}/${resource}`;

    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
    if (token) headers.Authorization = `JWT ${token}`;

    let requestBody = {
      method,
      url,
      headers,
    };

    // is a file is being uploaded
    if (onUploadProgress) {
      const fd = new FormData();
      fd.append('file', data);

      headers['Content-Type'] = 'multipart/form-data';

      return await axios({
        method,
        url,
        data: fd,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `JWT ${token}`,
          Accept: 'application/json',
        },
        onUploadProgress,
      });
    }

    if (method && data) {
      return await axios({ ...requestBody, data });
    } else if (method && !data) {
      return await axios(requestBody);
    } else {
      return axios.get(url);
    }
  };
}



// WEBPACK FOOTER //
// ./src/lib/ajax/index.js